import React from 'react';

import { generateMetaTags } from 'helpers/metaTags';
import DocMeta from 'components/DocMeta';
import ClientContactList from "../contacts/ClientContactList";
import {injectIntl} from "react-intl";
import {connect} from "react-redux";

class ContactManagement extends React.Component {


  render() {
    const {
      intl: { messages },
      contactReferenceId,
      updateDefaultContact,
      clientId,
    } = this.props;
    return (
      <DocMeta tags={generateMetaTags(messages.contact)}>
        <ClientContactList
          contactReferenceId={contactReferenceId}
          updateDefaultContact={updateDefaultContact}
          clientId={clientId}
        ></ClientContactList>
      </DocMeta>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.login.user,
    appIntl: state.intl,
  };
};

export default injectIntl(connect(mapStateToProps)(ContactManagement));
